import $ from 'jquery';

import createBehavior from '../create-behavior';


export default () => {
  class CollapsePanel {
    constructor($el, context, settings) {
      $el.find(".collapse-panel__trigger").on('click', function () {
        if ($(this).next('.collapse').hasClass('show'))
          $(this).find('.svg-icon').find('use').attr('xlink:href', 'svg/sprite.svg#arrow-right');
        else $(this).find('.svg-icon').find('use').attr('xlink:href', 'svg/sprite.svg#arrow-down');
      });
    }
  }

  createBehavior('.collapse-panel', 'CollapsePanel', CollapsePanel);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/collapse-panel.js